export default "__VITE_ASSET__a8e1efe3__"